module.exports = __webpack_public_path__ + "static/media/donna-desktop.a1af8e6a.jpg";